var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_611_18278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.09677 5.8718C5.09677 5.44696 5.44339 5.10256 5.87097 5.10256H8.96774C9.39532 5.10256 9.74194 5.44696 9.74194 5.8718C9.74194 6.29663 9.39532 6.64103 8.96774 6.64103H5.87097C5.44339 6.64103 5.09677 6.29663 5.09677 5.8718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09677 9.97436C5.09677 9.54953 5.44339 9.20513 5.87097 9.20513H14.129C14.5566 9.20513 14.9032 9.54953 14.9032 9.97436C14.9032 10.3992 14.5566 10.7436 14.129 10.7436H5.87097C5.44339 10.7436 5.09677 10.3992 5.09677 9.97436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09677 13.0513C5.09677 12.6264 5.44339 12.2821 5.87097 12.2821H14.129C14.5566 12.2821 14.9032 12.6264 14.9032 13.0513C14.9032 13.4761 14.5566 13.8205 14.129 13.8205H5.87097C5.44339 13.8205 5.09677 13.4761 5.09677 13.0513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09677 16.1282C5.09677 15.7034 5.44339 15.359 5.87097 15.359H14.129C14.5566 15.359 14.9032 15.7034 14.9032 16.1282C14.9032 16.553 14.5566 16.8974 14.129 16.8974H5.87097C5.44339 16.8974 5.09677 16.553 5.09677 16.1282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22679 1.22527C2.37199 1.08101 2.56893 0.999978 2.77428 1L8.22301 1.00059C8.23801 1.00059 8.25291 1.00101 8.2677 1.00185C8.75951 1.00399 9.24989 1.04142 9.72048 1.12614C12.0134 1.44433 13.9424 2.36204 15.3672 3.82097C16.9508 5.4425 17.8481 7.66769 17.981 10.3061C17.9909 10.4231 17.9965 10.5404 17.9979 10.6579C17.9993 10.6768 18 10.6958 18 10.7149V20.2308C18 20.6556 17.6534 21 17.2258 21H2.77419C2.34662 21 2 20.6556 2 20.2308V1.76923C2 1.5652 2.08158 1.36953 2.22679 1.22527ZM16.4516 11.0523C16.4504 11.035 16.4499 11.0176 16.4499 11C16.4499 10.8008 16.4452 10.6048 16.436 10.4122C16.4284 10.3296 16.4178 10.2473 16.404 10.1655C16.2281 9.11858 15.8999 8.36247 15.4572 7.91396C15.0555 7.50685 14.4846 7.27576 13.5747 7.42674L12.192 7.65616C11.9453 7.6971 11.6939 7.61709 11.5171 7.44137C11.3402 7.26564 11.2597 7.01585 11.3009 6.77073L11.5318 5.39697C11.5623 5.21552 11.5776 5.03187 11.5776 4.84791C11.5776 3.96113 11.2361 3.44009 10.7184 3.10337C10.3929 2.89163 9.97188 2.7376 9.47046 2.64469C9.06606 2.59002 8.64524 2.55612 8.20835 2.54401L7.92486 2.54014C7.91384 2.53999 7.90288 2.53961 7.89198 2.53901L3.54839 2.53854V19.4615H16.4516V11.0523ZM13.0214 3.88924C13.0902 4.18636 13.126 4.50602 13.126 4.84791C13.126 5.11677 13.1036 5.38518 13.059 5.65038L13.0068 5.96121L13.3196 5.9093C13.9808 5.79959 14.5841 5.82614 15.122 5.97896C14.8662 5.58316 14.5766 5.22063 14.256 4.89233C13.8897 4.51728 13.4777 4.18156 13.0214 3.88924Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_611_18278",
    x: 0,
    y: 0,
    width: 20,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_611_18278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_611_18278",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.19aae05bcd48a8e7e0ae6bb70c4ee413.svg";
export { ForwardRef as ReactComponent };